import React, { useRef, useEffect, FC, Fragment } from "react";
import { ChangeNames, Configuration } from "../clients/FirebaseClient/types";
import { BuildingAddressForm } from "./forms/BuildingAddressForm";
import { ProductClassesForm } from "./forms/ProductClassesForm";
import { NewConnectionBuildingUsagesForm } from "./forms/NewConnectionBuildingUsagesForm";
import { NewConnectionBuildingTypesForm } from "./forms/NewConnectionBuildingTypesForm";
import { NewConnectionCellarForm } from "./forms/NewConnectionCellarForm";
import { NewConnectionExteriorTypesForm } from "./forms/NewConnectionExteriorTypesForm";
import { ProductTypesForm } from "./forms/ProductTypesForm";
import { NewConnectionHousingUnitsForm } from "./forms/NewConnectionHousingUnitsForm";
import { ElectricBusinessDemandForm } from "./forms/ElectricBusinessDemandForm";
import { ElectricInfeedForm } from "./forms/ElectricInfeedForm";
import { ElectricLoaderForm } from "./forms/ElectricLoaderForm";
import { ElectricBoilerForm } from "./forms/ElectricBoilerForm";
import { ElectricElevatorForm } from "./forms/ElectricElevatorForm";
import { ElectricHeatingSystemForm } from "./forms/ElectricHeatingSystemForm";
import { ElectricMiscellaneousForm } from "./forms/ElectricMiscellaneousForm";
import { ModificationBuildingUsagesForm } from "./forms/ModificationBuildingUsagesForm";
import { ModificationHousingUnitsForm } from "./forms/ModificationHousingUnitsForm";
import { RemovalReconstructionBuildingUsagesForm } from "./forms/RemovalReconstructionBuildingUsagesForm";
import { RemovalReconstructionHousingUnitsForm } from "./forms/RemovalReconstructionHousingUnitsForm";
import { NewConnectionPowerFeedsForm } from "./forms/NewConnectionPowerFeedsForm";
import { NewConnectionRoofTypesForm } from "./forms/NewConnectionRoofTypesForm";
import { NewConnectionBuildingIntakesForm } from "./forms/NewConnectionBuildingIntakesForm";
import { NewConnectionGasFeedsForm } from "./forms/NewConnectionGasFeedsForm";
import { InvoiceRecipientForm } from "./forms/InvoiceRecipientForm";
import { PropertyOwnerForm } from "./forms/PropertyOwnerForm";
import { ApplicantForm } from "./forms/ApplicantForm";
import { NewConnectionGasDemandForm } from "./forms/NewConnectionGasDemandForm";
import { NewConnectionMultilineDesiresForm } from "./forms/NewConnectionMultilineDesiresForm";
import { NewConnectionMultilineVariantsForm } from "./forms/NewConnectionMultilineVariantsForm";
import { NewConnectionMultilineCellarOuterWallForm } from "./forms/NewConnectionMultilineCellarOuterWallForm";
import { NewConnectionMultilineBasePlateHeightForm } from "./forms/NewConnectionMultilineBasePlateHeightForm";
import { NewConnectionMultilineInstallationFrameInstalledByDistributionSystemOperatorForm } from "./forms/NewConnectionMultilineInstallationFrameInstalledByDistributionSystemOperatorForm";
import { NewConnectionMultilineContactAllowedForm } from "./forms/NewConnectionMultilineContactAllowedForm";
import { NewConnectionMultilineCellarCasingPipeDeliveredByDistributionSystemOperatorForm } from "./forms/NewConnectionMultilineCellarCasingPipeDeliveredByDistributionSystemOperatorForm";
import { NewConnectionMultilineCellarOuterWallBushingForm } from "./forms/NewConnectionMultilineCellarOuterWallBushingForm";
import { NewConnectionMultilineCellarInstallationFrameInstalledByDistributionSystemOperatorForm } from "./forms/NewConnectionMultilineCellarInstallationFrameInstalledByDistributionSystemOperatorForm";
import { ModificationPowerFeedsForm } from "./forms/ModificationPowerFeedsForm";
import { ModificationPowerCableForm } from "./forms/ModificationPowerCableForm";
import { ModificationPowerOverheadForm } from "./forms/ModificationPowerOverheadForm";
import { ModificationPowerJunctionBoxReplacementReasonForm } from "./forms/ModificationPowerJunctionBoxReplacementReasonForm";
import { ModificationPowerCableJunctionBoxRelocationDistanceForm } from "./forms/ModificationPowerCableJunctionBoxRelocationDistanceForm";
import { ModificationPowerCableRelocationDistanceForm } from "./forms/ModificationPowerCableRelocationDistanceForm";
import { ModificationPowerOverheadRoofPillarReassemblyLocationForm } from "./forms/ModificationPowerOverheadRoofPillarReassemblyLocationForm";
import { ModificationReasonForm } from "./forms/ModificationReasonForm";
import { ModificationGasRelocationDistanceForm } from "./forms/ModificationGasRelocationDistanceForm";
import { ModificationPersonalContributionWallBushingForm } from "./forms/ModificationPersonalContributionWallBushingForm";
import { ModificationPersonalContributionUndergroundWorkForm } from "./forms/ModificationPersonalContributionUndergroudWorkForm";

import { NewConnectionMultilinePersonalContributionCanDoUndergroundWorkForm } from "./forms/NewConnectionMultilinePersonalContributionCanDoUndergroundWorkForm";
import { NewConnectionMultilinePersonalContributionMustInfuseProvidedInstallationFrameForm } from "./forms/NewConnectionMultilinePersonalContributionMustInfuseProvidedInstallationFrameForm";
import { NewConnectionMultilinePersonalContributionMustDoUndergroundWorkForm } from "./forms/NewConnectionMultilinePersonalContributionMustDoUndergroundWorkForm";
import { NewConnectionMultilinePersonalContributionMustInstallCasingPipeForm } from "./forms/NewConnectionMultilinePersonalContributionMustInstallCasingPipeForm";
import { NewConnectionMultilinePersonalContributionCanDoWallBushingForm } from "./forms/NewConnectionMultilinePersonalContributionCanDoWallBushingForm";
import { NewConnectionMultilinePersonalContributionMustDoWallBushingForm } from "./forms/NewConnectionMultilinePersonalContributionMustDoWallBushingForm";
import { NewConnectionMultilinePersonalContributionMustInfuseOwnInstallationFrameForm } from "./forms/NewConnectionMultilinePersonalContributionMustInfuseOwnInstallationFrameForm";
import { ModificationCellarForm } from "./forms/ModificationCellarForm";
import { RemovalBuildingOccupationConfirmationForm } from "./forms/RemovalBuildingOccupationConfirmationForm";
import { RemovalPowerSubjectForm } from "./forms/RemovalPowerSubjectForm";
import { RemovalPersonalContributionUndergroundWorkForm } from "./forms/RemovalPersonalContributionCanDoUndergroundWorkForm";
import { RemovalReconstructionForm } from "./forms/RemovalReconstructionForm";
import { RemovalReconstructionProductClassesForm } from "./forms/RemovalReconstructionProductClassesForm";
import { ModificationElectricBusinessDemand } from "./forms/ModificationElectricBusinessDemandForm";
import { NewConnectionPersonalContributionCanDoUndergroundWorkForm } from "./forms/NewConnectionPersonalContributionCanDoUndergroundWorkForm";
import { NewConnectionPersonalContributionCanDoWallBushingForm } from "./forms/NewConnectionPersonalContributionCanDoWallBushingForm";
import { RemovalDateForm } from "./forms/RemovalDateForm";
import { RemovalReconstructionDateForm } from "./forms/RemovalReconstructionDateForm";
import { useStyles } from "../useStyles";
import { NewConnectionMultilineBuildingIntakeSpecification } from "./forms/NewConnectionMultilineBuildingIntakeSpecification";
import { NewConnectionPersonalContributionCanDoBasePlateBushingForm } from "./forms/NewConnectionPersonalContributionCanDoBasePlateBushingForm";
import { NewConnectionPersonalContributionMustDoBasePlateBushingForm } from "./forms/NewConnectionPersonalContributionMustDoBasePlateBushingForm";
import { ChargerSupplyConnectionForm } from "./forms/ChargerSupplyConnectionForm";
import { ChargerLocationForm } from "./forms/ChargerLocationForm";
import { ChargerPublicParkingUsagesForm } from "./forms/ChargerPublicParkingUsagesForm";
import { ChargerPrivateParkingUsagesForm } from "./forms/ChargerPrivateParkingUsagesForm";
import { AdjustableLoadBuildingUsagesForm } from "./forms/AdjustableLoadBuildingUsagesForm";
import { AdjustableLoadHousingUnitsForm } from "./forms/AdjustableLoadHousingUnitsForm";
import { AdjustableLoadElectricBusinessDemandForm } from "./forms/AdjustableLoadElectricBusinessDemandForm";
import { AdjustableLoadElectricBoilerForm } from "./forms/AdjustableLoadElectricBoilerForm";
import { AdjustableLoadElectricHeatPumpForm } from "./forms/AdjustableLoadElectricHeatPumpForm";
import { AdjustableLoadElectricElevatorForm } from "./forms/AdjustableLoadElectricElevatorForm";
import { AdjustableLoadElectricLoaderForm } from "./forms/AdjustableLoadElectricLoaderForm";
import { AdjustableLoadElectricMiscellaneousForm } from "./forms/AdjustableLoadElectricMiscellaneousForm";
import { AdjustableLoadHouseConnectionFuseCapacityForm } from "./forms/AdjustableLoadHouseConnectionFuseCapacityForm";
import { ChargerConnectionExteriorTypesForm } from "./forms/ChargerConnectionExteriorTypesForm";
import { ChargerConnectionPillarDeliveredBySystemOperatorForm } from "./forms/ChargerConnectionPillarDeliveredBySystemOperatorForm";
import { ChargerAdditionalElectricDemandForm } from "./forms/ChargerAdditionalElectricDemandForm";
import { ChargerChargingStationsForm } from "./forms/ChargerChargingStationsForm";
import { ChargerLoadManagementForm } from "./forms/ChargerLoadManagementForm";
import { AdjustableLoadElectricInstallationAgreementForm } from "./forms/AdjustableLoadElectricInstallationAgreementForm";
import { IncreaseBuildingUsagesForm } from "./forms/IncreaseBuildingUsagesForm";
import { IncreaseCurrentHousingUnitsForm } from "./forms/IncreaseCurrentHousingUnitsForm";
import { IncreaseCurrentElectricBusinessDemandForm } from "./forms/IncreaseCurrentElectricBusinessDemandForm";
import { IncreaseCurrentElectricBoilerForm } from "./forms/IncreaseCurrentElectricBoilerForm";
import { IncreaseCurrentGasDemandForm } from "./forms/IncreaseCurrentGasDemandForm";
import { IncreaseCurrentHeatPumpForm } from "./forms/IncreaseCurrentHeatPumpForm";
import { IncreaseCurrentElectricElevatorForm } from "./forms/IncreaseCurrentElectricElevatorForm";
import { IncreaseCurrentElectricLoaderForm } from "./forms/IncreaseCurrentElectricLoaderForm";
import { IncreaseCurrentElectricMiscellaneousForm } from "./forms/IncreaseCurrentElectricMiscellaneousForm";
import { IncreaseExpectedHousingUnitsForm } from "./forms/IncreaseExpectedHousingUnitsForm";
import { IncreaseExpectedGasDemandForm } from "./forms/IncreaseExpectedGasDemandForm";
import { IncreaseExpectedElectricBusinessDemandForm } from "./forms/IncreaseExpectedElectricBusinessDemandForm";
import { IncreaseExpectedElectricBoilerForm } from "./forms/IncreaseExpectedElectricBoilerForm";
import { IncreaseExpectedElectricHeatingSystemForm } from "./forms/IncreaseExpectedElectricHeatingSystemForm";
import { IncreaseExpectedElectricElevatorForm } from "./forms/IncreaseExpectedElectricElevatorForm";
import { IncreaseExpectedElectricLoaderForm } from "./forms/IncreaseExpectedElectricLoaderForm";
import { IncreaseExpectedElectricMiscellaneousForm } from "./forms/IncreaseExpectedElectricMiscellaneousForm";
import { IncreaseCurrentHouseConnectionFuseCapacityForm } from "./forms/IncreaseCurrentHouseConnectionFuseCapacityForm";
import { IncreaseAdditionalNotesForm } from "./forms/IncreaseAdditionalNotesForm";
import { IncreaseExpectedElectricRoomCoolingDeviceForm } from "./forms/IncreaseExpectedElectricRoomCoolingDeviceForm";
import { NewConnectionConnectionPillarDeliveredBySystemOperatorForm } from "./forms/NewConnectionConnectionPillarDeliveredBySystemOperatorForm";
import { ChargerPersonalContributionUndergroundWorkForm } from "./forms/ChargerPersonalContributionUndergroudWorkForm";
import { ElectricSharedElectricityForm } from "./forms/ElectricSharedElectricityForm";
import { ElectricSaunaForm } from "./forms/ElectricSaunaForm";
import { IncreaseCurrentElectricSharedElectricityForm } from "./forms/IncreaseCurrentElectricSharedElectricityForm";
import { IncreaseCurrentElectricSaunaForm } from "./forms/IncreaseCurrentElectricSaunaForm";
import { IncreaseExpectedElectricSharedElectricityForm } from "./forms/IncreaseExpectedElectricSharedElectricityForm";
import { IncreaseExpectedElectricSaunaForm } from "./forms/IncreaseExpectedElectricSaunaForm";
import { AdjustableLoadElectricSharedElectricityForm } from "./forms/AdjustableLoadElectricSharedElectricityForm";
import { AdjustableLoadElectricSaunaForm } from "./forms/AdjustableLoadElectricSaunaForm";
import { AdjustableLoadTypesForm } from "./forms/AdjustableLoadTypesForm";
import { SystemConstructorForm } from "./forms/SystemContructorForm";
import { AdjustableLoadDataSheetDownloadForm } from "./forms/AdjustableLoadDataSheetDownloadForm";
import { ElectricRoomCoolingDeviceForm } from "./forms/ElectricRoomCoolingDeviceForm";
import { ElectricHeatPumpDeviceForm } from "./forms/ElectricHeatPumpDeviceForm";
import { IncreaseExpectedElectricHeatPumpForm } from "./forms/IncreaseExpectedElectricHeatPumpForm";

interface Props {
    changeName: string;
    scrollIntoView?: boolean;
}

export const ChangeRenderer: React.FC<Props> = (props: Props) => {
    const changeReference = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!props.scrollIntoView) return;
        changeReference?.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
        });
    }, [props.scrollIntoView]);

    switch (props.changeName) {
        case ChangeNames.BUILDING_ADDRESS:
            return (
                <div ref={changeReference}>
                    <BuildingAddressForm />
                </div>
            );
        case ChangeNames.PRODUCT_TYPES:
            return (
                <div ref={changeReference}>
                    <ProductTypesForm />
                </div>
            );
        case ChangeNames.PRODUCT_CLASSES:
            return (
                <div ref={changeReference}>
                    <ProductClassesForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_TYPES:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadTypesForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_BUILDING_USAGES:
            return (
                <div ref={changeReference}>
                    <NewConnectionBuildingUsagesForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_BUILDING_TYPES:
            return (
                <div ref={changeReference}>
                    <NewConnectionBuildingTypesForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_CELLAR:
            return (
                <div ref={changeReference}>
                    <NewConnectionCellarForm />
                </div>
            );
        case ChangeNames.MODIFICATION_CELLAR:
            return (
                <div ref={changeReference}>
                    <ModificationCellarForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_EXTERIOR_TYPES:
            return (
                <div ref={changeReference}>
                    <NewConnectionExteriorTypesForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_CONNECTION_PILLAR_DELIVERED_BY_SYSTEM_OPERATOR:
            return (
                <div ref={changeReference}>
                    <NewConnectionConnectionPillarDeliveredBySystemOperatorForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_HOUSING_UNITS:
            return (
                <div ref={changeReference}>
                    <NewConnectionHousingUnitsForm />
                </div>
            );
        case ChangeNames.MODIFICATION_BUILDING_USAGES:
            return (
                <div ref={changeReference}>
                    <ModificationBuildingUsagesForm />
                </div>
            );
        case ChangeNames.MODIFICATION_HOUSING_UNITS:
            return (
                <div ref={changeReference}>
                    <ModificationHousingUnitsForm />
                </div>
            );
        case ChangeNames.MODIFICATION_GAS_RELOCATION_DISTANCE:
            return (
                <div ref={changeReference}>
                    <ModificationGasRelocationDistanceForm />
                </div>
            );
        case ChangeNames.MODIFICATION_POWER_FEEDS:
            return (
                <div ref={changeReference}>
                    <ModificationPowerFeedsForm />
                </div>
            );
        case ChangeNames.MODIFICATION_ELECTRIC_BUSINESS_DEMAND:
            return (
                <div ref={changeReference}>
                    <ModificationElectricBusinessDemand />
                </div>
            );
        case ChangeNames.MODIFICATION_POWER_CABLE:
            return (
                <div ref={changeReference}>
                    <ModificationPowerCableForm />
                </div>
            );

        case ChangeNames.MODIFICATION_POWER_CABLE_RELOCATION_DISTANCE:
            return (
                <div ref={changeReference}>
                    <ModificationPowerCableRelocationDistanceForm />
                </div>
            );

        case ChangeNames.MODIFICATION_POWER_CABLE_JUNCTION_BOX_RELOCATION_DISTANCE:
            return (
                <div ref={changeReference}>
                    <ModificationPowerCableJunctionBoxRelocationDistanceForm />
                </div>
            );

        case ChangeNames.MODIFICATION_POWER_JUNCTION_BOX_REPLACEMENT_REASON:
            return (
                <div ref={changeReference}>
                    <ModificationPowerJunctionBoxReplacementReasonForm />
                </div>
            );
        case ChangeNames.MODIFICATION_POWER_OVERHEAD:
            return (
                <div ref={changeReference}>
                    <ModificationPowerOverheadForm />
                </div>
            );
        case ChangeNames.MODIFICATION_POWER_OVERHEAD_ROOF_PILLAR_REASSEMBLY_LOCATION:
            return (
                <div ref={changeReference}>
                    <ModificationPowerOverheadRoofPillarReassemblyLocationForm />
                </div>
            );
        case ChangeNames.MODIFICATION_REASON:
            return (
                <div ref={changeReference}>
                    <ModificationReasonForm />
                </div>
            );
        case ChangeNames.MODIFICATION_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK:
            return (
                <div ref={changeReference}>
                    <ModificationPersonalContributionUndergroundWorkForm />
                </div>
            );
        case ChangeNames.MODIFICATION_PERSONAL_CONTRIBUTION_CAN_DO_WALL_BUSHING:
            return (
                <div ref={changeReference}>
                    <ModificationPersonalContributionWallBushingForm />
                </div>
            );
        case ChangeNames.REMOVAL_BUILDING_OCCUPATION_CONFIRMATION:
            return (
                <div ref={changeReference}>
                    <RemovalBuildingOccupationConfirmationForm />
                </div>
            );
        case ChangeNames.REMOVAL_POWER_SUBJECT:
            return (
                <div ref={changeReference}>
                    <RemovalPowerSubjectForm />
                </div>
            );
        case ChangeNames.REMOVAL_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK:
            return (
                <div ref={changeReference}>
                    <RemovalPersonalContributionUndergroundWorkForm />
                </div>
            );
        case ChangeNames.REMOVAL_RECONSTRUCTION:
            return (
                <div ref={changeReference}>
                    <RemovalReconstructionForm />
                </div>
            );
        case ChangeNames.REMOVAL_RECONSTRUCTION_PRODUCT_CLASSES:
            return (
                <div ref={changeReference}>
                    <RemovalReconstructionProductClassesForm />
                </div>
            );
        case ChangeNames.REMOVAL_RECONSTRUCTION_BUILDING_USAGES:
            return (
                <div ref={changeReference}>
                    <RemovalReconstructionBuildingUsagesForm />
                </div>
            );
        case ChangeNames.REMOVAL_RECONSTRUCTION_HOUSING_UNITS:
            return (
                <div ref={changeReference}>
                    <RemovalReconstructionHousingUnitsForm />
                </div>
            );
        case ChangeNames.REMOVAL_DATE:
            return (
                <div ref={changeReference}>
                    <RemovalDateForm />
                </div>
            );
        case ChangeNames.REMOVAL_RECONSTRUCTION_DATE:
            return (
                <div ref={changeReference}>
                    <RemovalReconstructionDateForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_ELECTRIC_BUSINESS_DEMAND:
            return (
                <div ref={changeReference}>
                    <ElectricBusinessDemandForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_ELECTRIC_INFEED:
            return (
                <div ref={changeReference}>
                    <ElectricInfeedForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_ELECTRIC_LOADER:
            return (
                <div ref={changeReference}>
                    <ElectricLoaderForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_ELECTRIC_LOADER_V2:
            return (
                <div ref={changeReference}>
                    <ElectricLoaderForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_ELECTRIC_BOILER:
            return (
                <div ref={changeReference}>
                    <ElectricBoilerForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_ELECTRIC_ELEVATOR:
            return (
                <div ref={changeReference}>
                    <ElectricElevatorForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_ELECTRIC_HEAT_PUMP_V2:
            return (
                <div ref={changeReference}>
                    <ElectricHeatPumpDeviceForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_ELECTRIC_HEATING_SYSTEM_V2:
            return (
                <div ref={changeReference}>
                    <ElectricHeatingSystemForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_ELECTRIC_ROOM_COOLING_DEVICE:
            return (
                <div ref={changeReference}>
                    <ElectricRoomCoolingDeviceForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_ELECTRIC_SHARED_ELECTRICITY:
            return (
                <div ref={changeReference}>
                    <ElectricSharedElectricityForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_ELECTRIC_SAUNA:
            return (
                <div ref={changeReference}>
                    <ElectricSaunaForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_ELECTRIC_MISCELLANEOUS:
            return (
                <div ref={changeReference}>
                    <ElectricMiscellaneousForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_POWER_FEEDS:
            return (
                <div ref={changeReference}>
                    <NewConnectionPowerFeedsForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_ROOF_TYPES:
            return (
                <div ref={changeReference}>
                    <NewConnectionRoofTypesForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_BUILDING_INTAKES:
            return (
                <div ref={changeReference}>
                    <NewConnectionBuildingIntakesForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_GAS_FEEDS:
            return (
                <div ref={changeReference}>
                    <NewConnectionGasFeedsForm />
                </div>
            );
        case ChangeNames.INVOICE_RECIPIENT:
            return (
                <div ref={changeReference}>
                    <InvoiceRecipientForm />
                </div>
            );
        case ChangeNames.PROPERTY_OWNER:
            return (
                <div ref={changeReference}>
                    <PropertyOwnerForm />
                </div>
            );
        case ChangeNames.APPLICANT:
            return (
                <div ref={changeReference}>
                    <ApplicantForm />
                </div>
            );
        case ChangeNames.SYSTEM_CONSTRUCTOR:
            return (
                <div ref={changeReference}>
                    <SystemConstructorForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_GAS_DEMAND:
            return (
                <div ref={changeReference}>
                    <NewConnectionGasDemandForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_DESIRES:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilineDesiresForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_BUILDING_INTAKE_SPECIFICATION:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilineBuildingIntakeSpecification />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_VARIANTS:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilineVariantsForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_OUTER_WALL:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilineCellarOuterWallForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_BASE_PLATE_HEIGHT:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilineBasePlateHeightForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_INSTALLATION_FRAME_INSTALLED_BY_DISTRIBUTION_SYSTEM_OPERATOR:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilineInstallationFrameInstalledByDistributionSystemOperatorForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_CONTACT_ALLOWED:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilineContactAllowedForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_OUTER_WALL_BUSHING:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilineCellarOuterWallBushingForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_INSTALLATION_FRAME_INSTALLED_BY_DISTRIBUTION_SYSTEM_OPERATOR:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilineCellarInstallationFrameInstalledByDistributionSystemOperatorForm />
                </div>
            );

        case ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_CASING_PIPE_DELIVERED_BY_DISTRIBUTION_SYSTEM_OPERATOR:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilineCellarCasingPipeDeliveredByDistributionSystemOperatorForm />
                </div>
            );

        case ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilinePersonalContributionCanDoUndergroundWorkForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_INFUSE_PROVIDED_INSTALLATION_FRAME:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilinePersonalContributionMustInfuseProvidedInstallationFrameForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_DO_UNDERGROUND_WORK:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilinePersonalContributionMustDoUndergroundWorkForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_INSTALL_CASING_PIPE:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilinePersonalContributionMustInstallCasingPipeForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_CAN_DO_WALL_BUSHING:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilinePersonalContributionCanDoWallBushingForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_DO_WALL_BUSHING:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilinePersonalContributionMustDoWallBushingForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_INFUSE_OWN_INSTALLATION_FRAME:
            return (
                <div ref={changeReference}>
                    <NewConnectionMultilinePersonalContributionMustInfuseOwnInstallationFrameForm />
                </div>
            );

        case ChangeNames.NEW_CONNECTION_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK:
            return (
                <div ref={changeReference}>
                    <NewConnectionPersonalContributionCanDoUndergroundWorkForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_PERSONAL_CONTRIBUTION_CAN_DO_WALL_BUSHING:
            return (
                <div ref={changeReference}>
                    <NewConnectionPersonalContributionCanDoWallBushingForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_PERSONAL_CONTRIBUTION_CAN_DO_BASE_PLATE_BUSHING:
            return (
                <div ref={changeReference}>
                    <NewConnectionPersonalContributionCanDoBasePlateBushingForm />
                </div>
            );
        case ChangeNames.NEW_CONNECTION_PERSONAL_CONTRIBUTION_MUST_DO_BASE_PLATE_BUSHING:
            return (
                <div ref={changeReference}>
                    <NewConnectionPersonalContributionMustDoBasePlateBushingForm />
                </div>
            );
        case ChangeNames.CHARGER_LOCATION:
            return (
                <div ref={changeReference}>
                    <ChargerLocationForm />
                </div>
            );
        case ChangeNames.CHARGER_PUBLIC_PARKING_USAGES:
            return (
                <div ref={changeReference}>
                    <ChargerPublicParkingUsagesForm />
                </div>
            );
        case ChangeNames.CHARGER_PRIVATE_PARKING_USAGES:
            return (
                <div ref={changeReference}>
                    <ChargerPrivateParkingUsagesForm />
                </div>
            );
        case ChangeNames.CHARGER_SUPPLY_CONNECTION:
            return (
                <div ref={changeReference}>
                    <ChargerSupplyConnectionForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_BUILDING_USAGE:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadBuildingUsagesForm />
                </div>
            );
        case ChangeNames.CHARGER_CONNECTION_EXTERIOR_TYPE:
            return (
                <div ref={changeReference}>
                    <ChargerConnectionExteriorTypesForm />
                </div>
            );
        case ChangeNames.CHARGER_CONNECTION_PILLAR_DELIVERED_BY_SYSTEM_OPERATOR:
            return (
                <div ref={changeReference}>
                    <ChargerConnectionPillarDeliveredBySystemOperatorForm />
                </div>
            );
        case ChangeNames.CHARGER_ADDITIONAL_ELECTRIC_DEMAND:
            return (
                <div ref={changeReference}>
                    <ChargerAdditionalElectricDemandForm />
                </div>
            );
        case ChangeNames.CHARGER_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK:
            return (
                <div ref={changeReference}>
                    <ChargerPersonalContributionUndergroundWorkForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_HOUSING_UNITS:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadHousingUnitsForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_BUSINESS_DEMAND:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadElectricBusinessDemandForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_BOILER:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadElectricBoilerForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_HEAT_PUMP:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadElectricHeatPumpForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_ELEVATOR:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadElectricElevatorForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_LOADER:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadElectricLoaderForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_SHARED_ELECTRICITY:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadElectricSharedElectricityForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_SAUNA:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadElectricSaunaForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_MISCELLANEOUS:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadElectricMiscellaneousForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_HOUSE_CONNECTION_FUSE_CAPACITY:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadHouseConnectionFuseCapacityForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_DATA_SHEET_DOWNLOAD:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadDataSheetDownloadForm />
                </div>
            );
        case ChangeNames.CHARGER_CHARGING_STATIONS:
            return (
                <div ref={changeReference}>
                    <ChargerChargingStationsForm />
                </div>
            );
        case ChangeNames.CHARGER_LOAD_MANAGEMENT:
            return (
                <div ref={changeReference}>
                    <ChargerLoadManagementForm />
                </div>
            );
        case ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_INSTALLATION_AGREEMENT:
            return (
                <div ref={changeReference}>
                    <AdjustableLoadElectricInstallationAgreementForm />
                </div>
            );
        case ChangeNames.INCREASE_BUILDING_USAGES:
            return (
                <div ref={changeReference}>
                    <IncreaseBuildingUsagesForm />
                </div>
            );
        case ChangeNames.INCREASE_CURRENT_HOUSING_UNITS:
            return (
                <div ref={changeReference}>
                    <IncreaseCurrentHousingUnitsForm />
                </div>
            );
        case ChangeNames.INCREASE_CURRENT_ELECTRIC_BUSINESS_DEMAND:
            return (
                <div ref={changeReference}>
                    <IncreaseCurrentElectricBusinessDemandForm />
                </div>
            );
        case ChangeNames.INCREASE_CURRENT_ELECTRIC_BOILER:
            return (
                <div ref={changeReference}>
                    <IncreaseCurrentElectricBoilerForm />
                </div>
            );
        case ChangeNames.INCREASE_CURRENT_GAS_DEMAND:
            return (
                <div ref={changeReference}>
                    <IncreaseCurrentGasDemandForm />
                </div>
            );
        case ChangeNames.INCREASE_CURRENT_ELECTRIC_HEAT_PUMP:
            return (
                <div ref={changeReference}>
                    <IncreaseCurrentHeatPumpForm />
                </div>
            );
        case ChangeNames.INCREASE_CURRENT_ELECTRIC_ELEVATOR:
            return (
                <div ref={changeReference}>
                    <IncreaseCurrentElectricElevatorForm />
                </div>
            );
        case ChangeNames.INCREASE_CURRENT_ELECTRIC_LOADER:
            return (
                <div ref={changeReference}>
                    <IncreaseCurrentElectricLoaderForm />
                </div>
            );
        case ChangeNames.INCREASE_CURRENT_ELECTRIC_SHARED_ELECTRICITY:
            return (
                <div ref={changeReference}>
                    <IncreaseCurrentElectricSharedElectricityForm />
                </div>
            );
        case ChangeNames.INCREASE_CURRENT_ELECTRIC_SAUNA:
            return (
                <div ref={changeReference}>
                    <IncreaseCurrentElectricSaunaForm />
                </div>
            );
        case ChangeNames.INCREASE_CURRENT_ELECTRIC_MISCELLANEOUS:
            return (
                <div ref={changeReference}>
                    <IncreaseCurrentElectricMiscellaneousForm />
                </div>
            );
        case ChangeNames.INCREASE_EXPECTED_GAS_DEMAND:
            return (
                <div ref={changeReference}>
                    <IncreaseExpectedGasDemandForm />
                </div>
            );

        case ChangeNames.INCREASE_EXPECTED_HOUSING_UNITS:
            return (
                <div ref={changeReference}>
                    <IncreaseExpectedHousingUnitsForm />
                </div>
            );

        case ChangeNames.INCREASE_EXPECTED_ELECTRIC_BUSINESS_DEMAND:
            return (
                <div ref={changeReference}>
                    <IncreaseExpectedElectricBusinessDemandForm />
                </div>
            );
        case ChangeNames.INCREASE_EXPECTED_ELECTRIC_BOILER:
            return (
                <div ref={changeReference}>
                    <IncreaseExpectedElectricBoilerForm />
                </div>
            );
        case ChangeNames.INCREASE_EXPECTED_ELECTRIC_HEATING_SYSTEM:
            return (
                <div ref={changeReference}>
                    <IncreaseExpectedElectricHeatingSystemForm />
                </div>
            );
        case ChangeNames.INCREASE_EXPECTED_ELECTRIC_HEAT_PUMP_V2:
            return (
                <div ref={changeReference}>
                    <IncreaseExpectedElectricHeatPumpForm />
                </div>
            );
        case ChangeNames.INCREASE_EXPECTED_ELECTRIC_ROOM_COOLING_DEVICE:
            return (
                <div ref={changeReference}>
                    <IncreaseExpectedElectricRoomCoolingDeviceForm />
                </div>
            );
        case ChangeNames.INCREASE_EXPECTED_ELECTRIC_ELEVATOR:
            return (
                <div ref={changeReference}>
                    <IncreaseExpectedElectricElevatorForm />
                </div>
            );
        case ChangeNames.INCREASE_EXPECTED_ELECTRIC_LOADER_V2:
            return (
                <div ref={changeReference}>
                    <IncreaseExpectedElectricLoaderForm />
                </div>
            );
        case ChangeNames.INCREASE_EXPECTED_ELECTRIC_SHARED_ELECTRICITY:
            return (
                <div ref={changeReference}>
                    <IncreaseExpectedElectricSharedElectricityForm />
                </div>
            );
        case ChangeNames.INCREASE_EXPECTED_ELECTRIC_SAUNA:
            return (
                <div ref={changeReference}>
                    <IncreaseExpectedElectricSaunaForm />
                </div>
            );
        case ChangeNames.INCREASE_EXPECTED_ELECTRIC_MISCELLANEOUS:
            return (
                <div ref={changeReference}>
                    <IncreaseExpectedElectricMiscellaneousForm />
                </div>
            );
        case ChangeNames.INCREASE_CURRENT_HOUSE_CONNECTION_FUSE_CAPACITY:
            return (
                <div ref={changeReference}>
                    <IncreaseCurrentHouseConnectionFuseCapacityForm />
                </div>
            );
        case ChangeNames.INCREASE_ADDITIONAL_NOTES:
            return (
                <div ref={changeReference}>
                    <IncreaseAdditionalNotesForm />
                </div>
            );
        default:
            return (
                <p>
                    {"'"}
                    {props.changeName}
                    {"'"} ist aktuell nicht implementiert
                </p>
            );
    }
};

interface MultiChangeRendererProps {
    changes: ChangeNames[];
    configuration: Configuration;
    scrollToChangeName?: string;
}
export const MultiChangeRenderer: FC<MultiChangeRendererProps> = (
    props: MultiChangeRendererProps,
) => {
    return (
        <Fragment>
            {props.changes
                .filter((changeName) => props.configuration.state[changeName]?.relevant)
                .map((changeName) => {
                    console.log({ changeName });
                    return (
                        <ChangeRenderer
                            key={changeName}
                            changeName={changeName}
                            scrollIntoView={changeName === props.scrollToChangeName}
                        />
                    );
                })}
        </Fragment>
    );
};

export const ContributionsSectionRenderer: FC<MultiChangeRendererProps> = (
    props: MultiChangeRendererProps,
) => {
    const classes = useStyles();
    const contributions = props.changes.filter(
        (changeName) => props.configuration.state[changeName]?.relevant,
    );
    if (!contributions.length) return <Fragment />;
    return (
        <Fragment>
            <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                Eigenleistung
            </h4>
            <p className={classes.p} style={{ marginBottom: 0 }}>
                Im Zuge der Herstellung Ihres Netzanschlusses können Sie einen Teil der Arbeiten in
                Eigenleistung erbringen
            </p>
            <MultiChangeRenderer {...props} />
        </Fragment>
    );
};
